<div class="pr-4 pl-4">
    <div class="flex flex-column w-6 mt-3">
    <label class="mb-3" for="status"><span class="red-color">*</span>Status:</label>
    <p-dropdown 
        id="status"
        [options]="status"
        (onChange)="statusChanged()"
        [(ngModel)]="selectedStatus"
        optionLabel="name"
        optionValue="value"
        optionDisabled="disabled"
        placeholder="Select Status" />
    </div>
</div>
